import request from "@/utils/request";
import qs from "qs";

/**
 * 查询订单
 * @param params
 * @returns {*}
 */
export function getPartnerList(params) {
  return request({
    url: "/agentOrder/getAgentPartnerList",
    method: "get",
    params,
 
  });
}

// 查询会员账户流水
export function getPartnerAccountList(params) {
  return request({
    url: "/agentOrder/getAcctFlow",
    method: "get",
    params
  });
}
